export default __webpack_public_path__ + "static/media/arrow.4dbfa0f9.svg";